export default "__VITE_ASSET__w0hR8h8L__"